import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";

export const Section = styled.div`
  padding-top: 80px;
  margin: 0 20px;

  @media ${device.desktop} {
    padding-top: 60px;
    max-width: 1080px;
    margin: 0 auto;
  }
`;

export const StyledSectionTitle = styled.h1`
  font-size: ${themes.textSize.m3};
  @media ${device.tablet} {
    font-size: ${themes.textSize.l1};
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.l2};
  }
`;

export const AccordionItemLabel = styled.div`
  display: block;
  padding: 15px 30px;
  font-size: ${themes.textSize.m1};
  font-weight: bold;
  height: fit-content;
  overflow: scroll;
  @media ${device.desktop} {
    font-size: ${themes.textSize.m3};
  }
`;
